export default [
    {
        path: '/country',
        props: true,
        component: () => import('@/views/Country'),
    },
];